import { registerPlugin } from "@capacitor/core";

export interface StashtBadgePlugin {
  setBadgeCount(options: { count: number }): Promise<{ success: boolean }>;
  clear(): Promise<{ success: boolean }>;
}

const StashtBadge = registerPlugin<StashtBadgePlugin>("StashtBadge", {
  web: {
    async setBadgeCount() {
      return { success: true };
    },
    async clear() {
      return { success: true };
    },
  },
});

export { StashtBadge };
